import { createContext, useContext, type RefObject } from 'react';

export const TransitionNodeRefContext =
  createContext<RefObject<HTMLElement | null> | null>(null);

/**
 * Provides a ref to downstream components to use for the animation declared ancestrally.
 * @returns The ref to be used by the downstream components.
 */
export const useTransitionNodeRef =
  (): RefObject<HTMLElement | null> | null => {
    const ref = useContext(TransitionNodeRefContext);

    return ref;
  };
